import WEEKLY_VEGGIES from "../assets/images/csa/weekly-veggies.png";
import LOCAL_FARMERS from "../assets/images/csa/local-farmers.png";
import SHARE from "../assets/images/csa/share.png";
import SECURITY from "../assets/images/csa/security.png";
import SEASONAL_COOKING from "../assets/images/csa/seasonal-cooking.png";
import UNIQUE_FLOWERS from "../assets/images/csa/unique-flowers.png";

export const CSAInfoCards = [
  {
    image: WEEKLY_VEGGIES,
    altText: "vegetables",

    body: {
      title: "Get weekly veggies (Jun-oct)",

      text: "Colorful, seasonal and nutritious vegetables grown with agroecological methods, love and care. ",
    },
  },
  {
    image: LOCAL_FARMERS,
    altText: "farmers market",

    body: {
      title: "Meet your local farmers",

      text: "We believe in a food system where producer and consumer are more closely connected so that we can build a fairer system.",
    },
  },
  {
    image: SHARE,
    altText: "happy costumer",

    body: {
      title: "Share the risks & benefits",

      text: "Farming is unpredictable. If a crop fails, we replace it with what’s ready to harvest. If something thrives, you get more.That’s the beauty of CSA — sharing the harvest, in every sense.",
    },
  },
  {
    image: SECURITY,
    altText: "farmers showing their farvest",

    body: {
      title: "Financial security for farmers",

      text: "Your upfront subscription gives farmers the financial security to grow with confidence, reduce waste, and plan the season ahead and ensures you’re covered with fresh veggies for almost five months.",
    },
  },
  {
    image: SEASONAL_COOKING,
    altText: "vegetables on a kitchen counter",

    body: {
      title: "Creative and seasonal cooking",

      text: "No more stressing about what to cook. Let your weekly “surprise” veggie box inspire you to try new flavors and eat with the seasons. Share ideas and recipes with fellow members in our WhatsApp group — and fill your table with colorful, creative dishes.",
    },
  },
  {
    image: UNIQUE_FLOWERS,
    altText: "a bouquet of flowers",

    body: {
      title: "Access to unique flowers",

      text: "Most flowers are mass-produced, grown with heavy pesticide use, and imported from far away. We grow our flowers locally, by hand, without harmful chemicals using beautiful heirloom varieties.",
    },
  },
];
